import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import fr from 'facet-rest';
import QualitativeQuestionLayout from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/QualitativeQuestion/Layout';
import {
  ActivePassiveIncomesLayout,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/ChooseIncomeCategories/ActivePassiveIncomesLayout';

const useChooseIncomeCategoriesLayout = () => {
  const { onboardingStepResource } = useSurveyContext();

  return onboardingStepResource.withRelationship(
    fr.relationships.activePassiveIncomeCategories.name,
    () => ActivePassiveIncomesLayout,
    () => QualitativeQuestionLayout,
  );
};

export { useChooseIncomeCategoriesLayout };
